export default "__VITE_ASSET__BIxJp_0K__"